module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/estimate_1-8c27b1c12c03246b350d5e37d966e32d.jpg";